import { Icon } from './Icon.js';
import { fmt, minutesSince } from '../lib/format.js';

/**
 * 縮退モードの帯。
 * 氏名が取れない＝取り違えの危険が最も高い状態を隠さずに伝える（要件12-2）。
 */
export function DegradedBar({
  since,
  now,
  onCalls,
}: {
  since: number;
  now: number;
  onCalls(): void;
}) {
  return (
    <div className="degraded">
      <Icon name="warning" />
      <div>
        <p>
          患者氏名を表示できません（{fmt(since)} から ／ {minutesSince(since, now)}分経過）
        </p>
        <small>ステータスの入力は続けられます。患者IDで照合し、取り違えに注意してください</small>
      </div>
      <button className="pill-btn danger" type="button" onClick={onCalls}>
        <Icon name="call" />
        電話運用に切り替える
      </button>
    </div>
  );
}
